document.addEventListener('DOMContentLoaded', function() {
  function initProductAccordions() {
    const productContainers = document.querySelectorAll('.product-info-container, .product-info-scroll-container');
    
    productContainers.forEach(container => {
      const accordions = container.querySelectorAll('.product__accordion details');
      
      accordions.forEach(details => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        
        // Remove any existing listeners
        const newSummary = summary.cloneNode(true);
        summary.parentNode.replaceChild(newSummary, summary);
        
        // Add new listener
        newSummary.addEventListener('click', function(e) {
          e.preventDefault();
          
          const isOpen = details.hasAttribute('open');
          
          if (!isOpen) {
            // Close all other accordions in the same container
            accordions.forEach(otherDetails => {
              if (otherDetails !== details) {
                otherDetails.removeAttribute('open');
              }
            });
            // Open this one
            details.setAttribute('open', '');
          } else {
            // Close this one
            details.removeAttribute('open');
          }
        });
      });
    });
  }
  
  // Initial setup
  initProductAccordions();
  
  // Reinitialize on variant change
  document.addEventListener('variant:change', function() {
    setTimeout(initProductAccordions, 100);
  });
});